// Common Client V2 imports
const { createFeedReducer } = require('client-v2/common/containers/feed/reducer')
// Sibling imports
const discoverActions = require('./actions')
const DiscoverRecord = require('./record')

module.exports = createFeedReducer(discoverActions, DiscoverRecord)
